import React, { FC, ReactElement, ChangeEvent } from 'react';

interface RadioButtonProps {
  id: any;
  name: string;
  value: string;
  label: string;
  elementType: string;
  isChecked: boolean;
  action: (event: ChangeEvent<HTMLInputElement>, elementType: string, id?: number, survey_id?: number) => void;
  formErrors?: string;
  stylePreset?: any;
  customStyle?: any;
  question_id?: number;
  errors?: string | boolean;
}

//@ts-ignore
const RadioButton: FC<RadioButtonProps> = ({
  id,
  name,
  value,
  label,
  isChecked,
  elementType,
  action,
  formErrors,
  stylePreset,
  question_id,
  errors,
}: RadioButtonProps): ReactElement => {
  const defineAdditionalClass = (style: string | undefined) => {
    switch (style) {
      case 'bordered':
        return 'isBordered';
      default:
        return ''
    }
  };

  const additionalClass = defineAdditionalClass(stylePreset);

  const uiElementType = elementType;

  return (
    <div className="container-radio-box" style={{ position: 'relative' }}>
      <div className={`radio-button ${additionalClass} ${isChecked ? 'isActive' : ''}`}>
        <label
          className={`radio-button__label ${formErrors !== '' ? 'isError' : ''}`}
        >
          <input
            className="radio-button__input"
            type='radio'
            id={id}
            name={name}
            value={value}
            checked={isChecked}
            onChange={(event: ChangeEvent<HTMLInputElement>) => action(event, uiElementType, id, question_id)}
          />

          <div className="radio-button__checkmark" />

          <span className="radio-button__label-text">{label}</span>
        </label>
      </div>
      {errors ? <h1 className='input__error'>Select one answer</h1> : <></>}
    </div>

  );

};

export default RadioButton;
